import React, { useEffect, useState } from 'react';
import PayrollLayout from '../../layouts/PayrollLayout';

export default function SalaryStructure() {
  const [structures, setStructures] = useState([]);

  useEffect(() => {
    // Dummy Salary Structures
    const dummyStructures = [
      {
        id: 1,
        name: 'Default Template',
        basic: 30000,
        hra: 15000,
        specialAllowance: 5000,
        incentives: 2000,
        deductions: {
          pf: 1800,
          esi: 0,
          pt: 200,
          tds: 2500,
        },
      },
      {
        id: 2,
        name: 'Senior Manager Template',
        basic: 60000,
        hra: 30000,
        specialAllowance: 10000,
        incentives: 8000,
        deductions: {
          pf: 3600,
          esi: 0,
          pt: 200,
          tds: 6000,
        },
      },
    ];

    setStructures(dummyStructures);
  }, []);

  const calculateTotalEarnings = (structure) => {
    return (
      structure.basic +
      structure.hra +
      structure.specialAllowance +
      structure.incentives
    );
  };

  const calculateTotalDeductions = (structure) => {
    return (
      structure.deductions.pf +
      structure.deductions.esi +
      structure.deductions.pt +
      structure.deductions.tds
    );
  };

  const calculateNetSalary = (structure) => {
    return calculateTotalEarnings(structure) - calculateTotalDeductions(structure);
  };

  return (
    <PayrollLayout title="Salary Structures">
      <div className="flex flex-col gap-y-2 font-poppins">

        {/* Header */}
        <div className="bg-white dark:bg-gray-900 p-4 mx-2 rounded-2xl shadow overflow-x-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <h2 className="md:text-xl text-lg font-semibold dark:text-white">Salary Templates</h2>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg">
            Add Template
          </button>
        </div>

        {/* Salary Structures Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mx-2">
          {structures.map((s) => (
            <div key={s.id} className="bg-white dark:bg-gray-900 dark:border-gray-700 p-4 rounded-2xl shadow border">
              <h3 className="text-lg font-semibold mb-2 dark:text-white">{s.name}</h3>
              <div className="text-sm space-y-1 mb-2">
                <div><span className="font-semibold dark:text-gray-500">Basic:</span> <span className='dark:text-white'>₹{s.basic}</span></div>
                <div><span className="font-semibold dark:text-gray-500">HRA:</span> <span className='dark:text-white'>₹{s.hra}</span></div>
                <div><span className="font-semibold dark:text-gray-500">Special Allowance:</span> <span className='dark:text-white'>₹{s.specialAllowance}</span></div>
                <div><span className="font-semibold dark:text-gray-500">Incentives:</span> <span className='dark:text-white'>₹{s.incentives}</span></div>
              </div>

              <div className="border-t dark:border-gray-700 pt-2 mt-2 text-sm space-y-1">
                <div className="font-semibold dark:text-white">Deductions:</div>
                <div className='dark:text-white'>PF: <span className='dark:text-white'>₹{s.deductions.pf}</span></div>
                <div className='dark:text-white'>ESI: <span className='dark:text-white'>₹{s.deductions.esi}</span></div>
                <div className='dark:text-white'>PT: <span className='dark:text-white'>₹{s.deductions.pt}</span></div>
                <div className='dark:text-white'>TDS: <span className='dark:text-white'>₹{s.deductions.tds}</span></div>
              </div>

              <div className="border-t dark:border-gray-700 pt-2 mt-2 text-sm">
                <div><span className="font-semibold dark:text-gray-500">Total Earnings:</span> <span className='dark:text-white'>₹{calculateTotalEarnings(s)}</span></div>
                <div><span className="font-semibold dark:text-gray-500">Total Deductions:</span> <span className='dark:text-white'>₹{calculateTotalDeductions(s)}</span></div>
                <div className="font-semibold text-green-600">Net Salary: <span className='dark:text-white'>₹{calculateNetSalary(s)}</span></div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </PayrollLayout>
  );
}
